import { render } from "./CircleButton.vue?vue&type=template&id=70670a0b"
import script from "./CircleButton.vue?vue&type=script&lang=js"
export * from "./CircleButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/robin/encyon/w/group/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__